var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bags-hero"},[_c('div',{staticClass:"bags-hero-text"},[_c('h1',[_vm._v("Leather Bags")]),_c('p',[_vm._v(" Discover timelass leather bags crafted for everyday style, comfort, and lasting quality. ")])]),_c('div',{staticClass:"bags-hero-image"},[_c('img',{attrs:{"src":require("../assets/theclassic.avif"),"alt":"Leather Bags"}})])])
}]

export { render, staticRenderFns }